import { APITypesV1 } from "@cur8/api-client";
import { paths } from "render/routes/paths";

export type SkinScannerRouting = {
  patientId: string;
  visitId: string;
  bloodWorkMode: APITypesV1.BloodWorkMode | undefined;
  bloodWorkAlreadyComplete: boolean;
  showBloodDrawStep: boolean;
  bloodDrawAlreadyRecorded: boolean;
};

export function nextDestinationAfterSkinScanner(
  routing: SkinScannerRouting
): string {
  const { patientId, visitId } = routing;

  if (needsVialAssignment(routing)) {
    return paths.assignVials.url({ patientId, visitId });
  }
  if (needsBloodDrawStep(routing)) {
    return paths.drawConfirmationStep.url({ patientId, visitId });
  }
  return paths.checkInSuccess.url({ patientId, visitId });
}

// LimsManaged samples and BarcodeAssignment are separate models, so vial
// assignment taking the slot should never be what hides the blood draw step.
// Nothing enforces that, so the caller reports it if it ever happens.
export function bloodModelsCompete(routing: SkinScannerRouting): boolean {
  return needsVialAssignment(routing) && routing.showBloodDrawStep;
}

function needsVialAssignment({
  bloodWorkMode,
  bloodWorkAlreadyComplete,
}: SkinScannerRouting): boolean {
  return (
    bloodWorkMode === APITypesV1.BloodWorkMode.BarcodeAssignment &&
    !bloodWorkAlreadyComplete
  );
}

// The step is where the draw gets recorded, so a visit with every tube already
// recorded has nothing to do there: it would open on a screen whose only button
// offers to skip a draw that has already happened. Same shape as the vial
// branch, which has never sent the operator back to assign assigned vials.
//
// Deliberately not folded into `showBloodDrawStep`: that stays "this visit has
// blood work the step covers", which is what `bloodModelsCompete` reports on.
function needsBloodDrawStep({
  showBloodDrawStep,
  bloodDrawAlreadyRecorded,
}: SkinScannerRouting): boolean {
  return showBloodDrawStep && !bloodDrawAlreadyRecorded;
}
